__turbopack_context__.v({
  "slider": "style-module-scss-module__jzycDq__slider",
});
